import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'
import { json } from 'd3'

import config from '../../../config/settings'




const state = {
    server_data: [],
}

const getters = {
    contactData: function (state, getters, rootState, rootGetters) {
        let contacts = state.server_data.length > 0 ? JSON.parse(JSON.stringify(state.server_data)) : [];
        contacts.map(contactItem => {
            let investedCompanies = [], foundedCompanies = [];
            contactItem.foundedCompanies.map(foundedItem => {
                if (foundedItem.name) foundedCompanies.push(foundedItem.name)
            })
            contactItem.investedCompanies.map(investItem => {
                if (investItem.name) investedCompanies.push(investItem.name)
            })
        })
        return contacts;
    },
    getParsedContactData: function (state) {
        let contacts = state.server_data.length > 0 ? JSON.parse(JSON.stringify(state.server_data)) : [];
        contacts = contacts.filter(contactItem => {
            let investedCompanies = [], foundedCompanies = [], tags = [], foundedCompaniesLogos = [], investedCompaniesLogos = [], founderCompanyLogoHtml = '', investedCompaniesLogoHtml = '';
            if (contactItem.context == "founder" || (contactItem.context == "investor" && contactItem.type == 'Person')) {
                contactItem.foundedCompanies.map(foundedItem => {
                    if (foundedItem.name) foundedCompanies.push(foundedItem.name)
                    if (foundedItem.tags) tags = [...foundedItem.tags];
                    if (foundedItem.logo_url) {
                        let obj = {};
                        obj.logo_url = foundedItem.hasOwnProperty('image_id') && foundedItem.image_id.length > 0
                            ? `${config.CRUNCHBASE_IMAGE_URL}/${foundedItem.image_id}`
                            : foundedItem.logo_url;
                        obj.name = foundedItem.name;
                        foundedCompaniesLogos.push(obj);
                    }
                })
                contactItem.investedCompanies.map(investItem => {
                    if (investItem.name) investedCompanies.push(investItem.name)
                    if (investItem.tags) tags = [...investItem.tags];
                    if (investItem.logo_url) {
                        let obj = {};
                        obj.logo_url = investItem.hasOwnProperty('image_id') && investItem.image_id.length > 0
                            ? `${config.CRUNCHBASE_IMAGE_URL}/${investItem.image_id}`
                            : investItem.logo_url;
                        obj.name = investItem.name;
                        investedCompaniesLogos.push(obj);
                    }
                })
                contactItem.investedCompaniesName = [...new Set(investedCompanies)].toString();
                contactItem.foundedCompaniesName = [...new Set(foundedCompanies)].toString();
                contactItem.tags = [...new Set(tags)].toString();
                foundedCompaniesLogos.map((item, index) => {
                    if (item &&
                        item.hasOwnProperty('logo_url') &&
                        item.hasOwnProperty('name') &&
                        item.logo_url.length > 0 &&
                        item.name.length > 0) {
                        if (index == 0) {
                            item.html = `<div class="suggestionConnectionImagesDiv"><img class="suggestionConnectionImages" src=${item.logo_url} title='${item.name}' style="margin-top: -5px;" /></div>`;
                        }
                        else {
                            item.html = foundedCompaniesLogos[index - 1].name != item.name ? `<div class="suggestionConnectionImagesDiv" style="margin-left:-18px;"><img class="suggestionConnectionImages" src=${item.logo_url} title='${item.name}' style="margin-top: -5px;" /></div>` : '';
                        }
                        founderCompanyLogoHtml += item.html;
                    }
                });
                investedCompaniesLogos.map((item, index) => {
                    if (item &&
                        item.hasOwnProperty('logo_url') &&
                        item.hasOwnProperty('name') &&
                        item.logo_url.length > 0 &&
                        item.name.length > 0) {
                        if (index == 0) {
                            item.html = `<div class="suggestionConnectionImagesDiv"><img class="suggestionConnectionImages" src=${item.logo_url} title='${item.name}' style="margin-top: -5px;" /></div>`;
                        }
                        else {
                            item.html = investedCompaniesLogos[index - 1].name != item.name ? `<div class="suggestionConnectionImagesDiv" style="margin-left:-10px;"><img class="suggestionConnectionImages" src=${item.logo_url} title='${item.name}' style="margin-top: -5px;" /></div>` : '';
                        }
                        investedCompaniesLogoHtml += item.html;
                    }
                });
                contactItem.foundedCompaniesLogos = foundedCompaniesLogos;
                contactItem.investedCompaniesLogos = investedCompaniesLogos;
                contactItem.foundedCompaniesLogoHtml = founderCompanyLogoHtml;
                contactItem.investedCompaniesLogoHtml = investedCompaniesLogoHtml;
                return contactItem;
            }
        })
        return contacts;
    }
}

const mutations = {
    initialize(state) {
        state.server_data = []
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a.master_pid === addr.master_pid })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        state.server_data = _.filter(state.server_data, function (a) { return a.master_pid !== payload })
    }
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('getContacts')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    getContacts({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/contacts/${fiifi.workspace_id}`;
                return api.get(url)
                    .then(res => {
                        commit('merge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostContact({ dispatch, commit }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/contact`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('getContacts')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchContact({ dispatch, commit }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/contact`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('getContacts')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteContact({ dispatch, commit }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/delete/contact`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                payload.map(item => {
                    commit('remove', item);
                })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}